"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _Map = _interopRequireDefault(require("vue-baidu-map/components/map/Map.vue"));
var _MapType = _interopRequireDefault(require("vue-baidu-map/components/controls/MapType.vue"));
var _Marker = _interopRequireDefault(require("vue-baidu-map/components/overlays/Marker.vue"));
var _user = require("@/api/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: ['editItem', 'id'],
  components: {
    BaiduMap: _Map.default,
    MapType: _MapType.default,
    MapMarker: _Marker.default
  },
  data: function data() {
    return {
      mapAK: '',
      dialogVisible: false,
      showMap: false,
      //变量代替dialogVisible，避免关闭时闪烁
      center: {
        // 地图中心点位置，可以根据需要设置为输入的详细地址对应的经纬度
        lng: 0,
        lat: 0
      },
      zoom: 17,
      // 地图缩放级别
      markerPosition: {
        // 标记点位置，可以根据需要设置为输入的详细地址对应的经纬度
        lng: 0,
        lat: 0
      },
      address: '',
      // 用户输入的详细地址
      geocoder: undefined,
      imgEndSrc: require('@/assets/images/map/map-filling.png'),
      loading: true
    };
  },
  watch: {
    dialogVisible: function () {
      var _dialogVisible = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(val) {
        var _this = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!val) {
                  _context.next = 11;
                  break;
                }
                _context.next = 3;
                return this.getMapKey();
              case 3:
                this.mapAK = _context.sent;
                setTimeout(function () {
                  _this.loading = false;
                }, 500);
                if (this.mapAK.length) {
                  _context.next = 10;
                  break;
                }
                this.$message({
                  message: '百度地图AK秘钥不存在，请先配置百度地图AK秘钥',
                  type: 'error'
                });
                return _context.abrupt("return");
              case 10:
                this.showMap = val;
              case 11:
                if (!val) {
                  setTimeout(function () {
                    _this.loading = true;
                    _this.showMap = val; //close after the dialog be closed
                  }, 200);
                }
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function dialogVisible(_x) {
        return _dialogVisible.apply(this, arguments);
      }
      return dialogVisible;
    }()
  },
  methods: {
    getMapKey: function getMapKey() {
      return new Promise(function (resolve, reject) {
        (0, _user.getConfig)({
          path: 'global.baidumap'
        }).then(function (res) {
          console.log('getConfig about supplier', res);
          resolve(res);
        });
      });
    },
    initMapPosition: function initMapPosition() {
      this.address = this.editItem;
    },
    showAddressinfo: function showAddressinfo(mapData) {
      var _this2 = this;
      var address = mapData.address,
        city = mapData.city;
      this.geocoder.getPoint(address, function (point) {
        if (point) {
          _this2.center.lng = point.lng;
          _this2.center.lat = point.lat;
          _this2.markerPosition = {
            lng: point.lng,
            lat: point.lat
          };
        }
      }, city);
    },
    //地图加载后的回调
    mapReady: function mapReady(_ref) {
      var BMap = _ref.BMap,
        map = _ref.map;
      // 获取自动定位方法
      this.geocoder = new BMap.Geocoder();
      this.initMapPosition();
      this.showAddressinfo(this.address);
    }
  }
};
exports.default = _default;